import { render } from "./index.vue?vue&type=template&id=225ea2d4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=225ea2d4&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=225ea2d4&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225ea2d4"]])

export default __exports__